import React from "react";
import PostJobs from "../../Administrative/PostJobs";

const PostYuvasarthiJobs = () => {
  return (
    <div>
      <PostJobs role="Super Admin" />
    </div>
  );
};

export default PostYuvasarthiJobs;
